import { ContainerSize, Highlight } from '@lib/types';
import Container from '@components/container';

export type HighlightSectionProps = {
  data: Highlight;
};

export default function HighlightSection({
  data: { text },
}: HighlightSectionProps) {
  return (
    <Container size={ContainerSize.wide}>
      <div className="grid grid-cols-12 gap-1.5 md:gap-6">
        <div className="col-span-12 md:col-span-8 md:col-start-3 grid grid-cols-12 md:grid-cols-8 gap-1.5 md:gap-6 pt-6 md:pt-14 pb-8 md:pb-16 bg-blue-200 rounded-xl md:rounded-3xl">
          <div className="col-span-10 md:col-span-6 col-start-2 md:col-start-2">
            <h1 className="text-23 md:text-35 leading-130 font-bold text-blue-800 ">
              {text}
            </h1>
          </div>
        </div>
      </div>
    </Container>
  );
}
